import Num2persian from "num2persian";
const DeleteShebaCard = () =>
  import("@/components/BankCard/DeleteShebaCard/index");
const DeleteBankCard = () =>
  import("@/components/BankCard/DeleteBankCard/index");
const AddShebaCard = () => import("@/components/BankCard/AddShebaCard/index");
// import Num2persian from "num2persian";
const NumberInput = () => import("@/components/NumberInput/index");
const NotRegisteredShebaCard = () =>
  import("@/components/BankCard/NotRegisteredShebaCard/index");
const AddCard = () => import("@/components/BankCard/AddCard/index");
const OtpVerify = () => import("@/components/Shared/OtpVerify/index");

import { BankService, OperationService, WalletService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import $carrySignFixed from "@/mixins/carrySignFixed";
import $exponent from "@/mixins/exponent";
import * as types from "@/store/types";
import { mapGetters } from "vuex";
import Stepper from "@/components/Shared/Stepper/index.vue"

export default {
  name: "rial",
  components: {
    DeleteShebaCard,
    DeleteBankCard,
    AddShebaCard,
    NumberInput,
    NotRegisteredShebaCard,
    AddCard,
    OtpVerify,
    Stepper
  },
  props: [],
  mixins: [$thousandMask, $carrySignFixed, $exponent],
  data() {
    return {
      dialog: false,
      deleteCardModal: false,
      selectedSheba: "",
      selectedCard: "",
      removedBankData: {},
      removedSheba: {},
      modalStatus: "",
      amount: "0",
      shebaData: {},
      shebaList: [],
      cardList: [],
      orderAmount: "0",
      orderId: "",
      phoneNumber: "",
      loading: false,
      max: true,
      shebaValidation: "",
      shebaStatus: "",
      isVerified: true,
      deleteShebaLoading: false,
      addCardDialog: false,
      addShebaLoading: false,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      withdrawStatus: false,
      withdrawType: [
        {
          id: 1,
          type: this.$t("operationsPage.withdraw.category.rial.depositToSheba"),
          title: "",
          hasAmount: false,
          list: []
        },
        // {
        //   id: 0,
        //   type: this.$t("operationsPage.withdraw.category.rial.depositToCard"),
        //   title: this.$t(
        //     "operationsPage.withdraw.category.rial.depositToCardTitle"
        //   ),
        //   hasAmount: true,
        //   list: []
        // }
      ],
      withdrawId: 1,
      channelLabel: [],
      minimum_amount_to: "",
      getWallets: {},
      getExchanges: {},
      availableAmount: "0",
      minWithdraw: null,
      maxWithdraw: null,
      selectedCurrency: this.$route.query.from,
      rialNetwork: null,
      rialFee: null
    };
  },
  computed: {
    ...mapGetters({
      // getExchanges: types.wallets.getters.GET_EXCHANGE_WALLETS,
      // getWallets: types.operations.getters.GET_WALLET,
      getUserInfo: types.userInfo.getters.GET_USER_INFO
    }),
    isVerify() {
      return !!this.getUserInfo.actions?.withdraw_rial?.is_active;
    },
    // fromCurrency() {
    //   if (Object.entries(this.getWallets).length > 0) {
    //     return this.getWallets.wallets.filter((elem) => {
    //       if (elem.currency.iso === "IRR") {
    //         return elem;
    //       }
    //     });
    //   }
    // },      console.log(number);

    // shebaRegex() {
    //   return this.fromCurrency[0].networks[0].regex;
    // },
    handleNumber2Persian() {
      let str = this.orderAmount.toString();
      str = str?.replace(/,/gi, "");
      return Num2persian(parseInt(str / 10));
    },
    IrrExchange() {
      // let min,
      //   max,
      //   balance,
      //   iso = "";
      // if (
      //   Object.entries(this.getExchanges).length > 0 &&
      //   Object.entries(this.getWallets).length > 0
      // ) {
      //   this.getWallets.wallets.find((item) => {
      //     if (item.currency.iso === "IRR") {
      //       balance = parseFloat(item.balance_string_format);
      //     }
      //   });
      //   this.getExchanges["IRR"].find((elem) => {
      //     if (elem.to === "IRR") {
      //       min = parseFloat(elem.minimum_amount_to);
      //       this.minimum_amount_to = parseFloat(elem.minimum_amount_to);
      //       max = parseFloat(elem.maximum_amount_to);
      //       iso = elem.to;
      //     }
      //     if (this.withdrawId === 0) {
      //       max = this.getUserInfo.card_to_card_max_amount;
      //     }
      //   });
      //   if (this.orderAmount === 0 || this.orderAmount === "") {
      //     return "";
      //   } else if (this.orderAmount > balance) {
      //     return "موجودی کیف پول شما کافی نیست.";
      //   } else if (this.orderAmount > max) {
      //     return `حداکثر مقدار قابل برداشت ${this.$thousandMask(
      //       max
      //     )} ${iso} است.`;
      //   } else if (this.orderAmount < min) {
      //     return `حداقل مقدار قابل برداشت ${this.$thousandMask(
      //       min
      //     )} ${iso} است.`;
      //   } else {
      //     return "";
      //   }
      // }

      //after refactor
      if (this.orderAmount === 0 || this.orderAmount === "") {
        return "";
      } else if (
        parseFloat(this.orderAmount) > parseFloat(this.availableAmount)
      ) {
        return this.$t("operationsPage.transfer.balanceNotEnought");
      } else if (parseFloat(this.orderAmount) > parseFloat(this.maxWithdraw)) {
        return this.$t("operationsPage.transfer.maxTransfer", {
          amount: `${this.$thousandMask(this.maxWithdraw)} ${
            this.selectedCurrency
          }`
        });
      } else if (parseFloat(this.orderAmount) < parseFloat(this.minWithdraw)) {
        return this.$t("operationsPage.transfer.minTransfer", {
          amount: `${this.$thousandMask(this.minWithdraw)} ${
            this.selectedCurrency
          }`
        });
      } else {
        return "";
      }
    },
    checkShebaForm() {
      if (
        Number(this.orderAmount) >= Number(this.minimum_amount_to) &&
        this.selectedSheba
      )
        return false;
      else return true;
    },
    checkCardForm() {
      if (
        Number(this.orderAmount) >= Number(this.minimum_amount_to) &&
        this.selectedCard &&
        this.selectedCard.id
      )
        return false;
      else return true;
    }
  },
  mounted() {
    this.getShebaList();
    this.getCardList();
    // this.getWalletService();
    // this.getExchangeService();
    // this.getUserInformation();
    this.getWalletDetails();
    this.getNetwork();
  },
  methods: {
    channelLabelFunc(data) {
      this.channelLabel = data;
    },
    // getUserInformation() {
    //   AuthService.userInfo().then(response => {
    //     this.isVerified = response.data.data.is_verified;
    //   });
    // },
    resetValues() {
      this.selectedCard = null;
      this.selectedSheba = null;
    },
    onSelectSheba(shebaCode) {
      this.selectedSheba = shebaCode;
    },
    checkShebaFormat(sheba) {
      if (
        sheba.indexOf("IR") !== 0 &&
        !sheba.includes("IR") &&
        sheba.length === 24
      ) {
        this.selectedSheba = "IR" + sheba;
      } else {
        this.selectedSheba = sheba;
      }
      if (!this.selectedSheba.match(this.rialNetwork.regex)) {
        this.shebaValidation = this.$t(
          "operationsPage.withdraw.category.rial.shebaNotCorrect"
        );
      } else {
        this.shebaValidation = "";
      }
      if (!this.selectedSheba) {
        this.shebaValidation = "";
      }
    },
    orderRialWithdraw() {
      this.loading = true;
      let data = {};
      data = {
        amount: this.orderAmount
      };
      if (this.selectedSheba) {
        data.to_address = this.selectedSheba.address
          ? this.selectedSheba.address
          : this.selectedSheba;
      }

      if (this.selectedCard) {
        data.to_address = this.selectedCard.card_number;
      }

      OperationService.withdrawIRR(data)
        .then(response => {
          this.orderId = response.data.data.ref_no;
          this.$router.push(
            `/submit-order/${this.orderId}/withdrawal/rial`,
            () => {}
          );
          this.selectedSheba = "";
        })
        .finally(() => {
          this.loading = false;
          this.checkShebaFormat(this.selectedSheba);
        });
    },
    onRemoveCard(item) {
      this.removedBankData = item;
      this.deleteCardModal = !this.deleteCardModal;
    },
    onConfirmBankCardRemove(event) {
      BankService.deleteCard(this.removedBankData.id).then(response => {
        this.selectedCard = "";
        this.$toast.success(response.data.message);
        this.deleteCardModal = event;
        this.getCardList();
      });
    },
    onRemoveSheba(item) {
      this.modalStatus = "removeSheba";
      this.removedSheba = item;
      this.dialog = !this.dialog;
    },
    onConfirmRemove(event, loading) {
      this.deleteShebaLoading = loading;
      let data = {
        address: this.removedSheba.address
      };
      OperationService.deleteSheba(data)
        .then(response => {
          this.selectedSheba = "";
          this.$toast.success(response.data.message);
          this.dialog = event;
          this.getShebaList();
        })
        .finally(() => {
          this.deleteShebaLoading = false;
        });
    },
    onAddSheba() {
      this.modalStatus = "addSheba";
      this.dialog = true;
    },
    onAddCard() {
      this.addCardDialog = true;
    },
    onConfirmAdd(event, address, name, loading) {
      this.addShebaLoading = loading;
      let data = {
        address: address,
        name: name
      };
      OperationService.storeSheba(data)
        .then(response => {
          this.dialog = event;
          this.$toast.success(response.data.message);
          this.getShebaList();
          this.selectedSheba = address;
        })
        .catch(error => {
          this.modalStatus = "cancelSheba";
          this.dialog = true;
          this.shebaStatus =
            error.data.errors.length !== 0
              ? error.data.errors.address[0]
              : error.data.message;
        })
        .finally(() => {
          this.addShebaLoading = false;
        });
    },
    getShebaList() {
      OperationService.getShebaList().then(response => {
        this.shebaList = response.data.data;
      });
    },
    getCardList() {
      OperationService.getBankCard().then(response => {
        this.cardList = response.data.data;
      });
    },
    addShebaAgain(data) {
      if (data) {
        this.modalStatus = "addSheba";
      }
    },
    getWalletService() {
      WalletService.getWalletV4().then(response => {
        this.getWallets = response.data.data;
      });
    },
    getExchangeService() {
      WalletService.getExchanges().then(response => {
        this.getExchanges = response.data.data;
      });
    },

    getWalletDetails() {
      WalletService.getWalletDetailsV2(this.$route.query.from || "IRR").then(
        response => {
          this.availableAmount = response.data.data.balance?.available;
        }
      );
    },

    getNetwork() {
      OperationService.getNetworkV2(this.$route.query.from).then(response => {
        this.rialFee = response.data.data.networks.filter(
          network => network.title == "RIAL"
        )[0].transfer_fee.amount;
        // this.rialNetwork = response.data.data.networks[0];
        this.minWithdraw = response.data.data.limitation_amount?.withdraw?.min;
        this.maxWithdraw = response.data.data.limitation_amount?.withdraw?.max;
      });
    }
  }
};
